import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-cierant-checkbox',
  templateUrl: './cierant-checkbox.component.html',
  styleUrls: ['./cierant-checkbox.component.scss']
})
export class CierantCheckboxComponent implements OnInit {
  @Input() checked: boolean;
  @Output() checkedChange = new EventEmitter();
  @Output() checkedChanged = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  onCheckChange() {
    this.checked = !this.checked;
    this.checkedChange.emit(this.checked);
    this.checkedChanged.emit(this.checked);
  }

}


// WEBPACK FOOTER //
// ./src/app/shared/components/cierant-checkbox/cierant-checkbox.component.ts